// extracted by mini-css-extract-plugin
export default {"wrapper":"P6C6jUEiQC_405k6BOsL","dot":"o_noMsLw7JlEEhzBxfgG","bounce":"BZ0mcYdgOBP1DdsGpfwd"};